import { FC } from 'react'
import { Icon, IconButton } from '@branch-messenger/willow-ui'
import { ChevronLeft } from '@branch-messenger/willow-ui/icons'
import { useRouter } from '@tanstack/react-router'

interface Props {
  back?: () => void
}

export const RouterBackButton: FC<Props> = ({ back }) => {
  const router = useRouter()
  const handleBackClick = () => {
    back ? back() : router.history.back()
  }
  return (
    <IconButton
      data-testid="routerBackButton"
      onClick={handleBackClick}
      size="sm"
      type="button"
    >
      <Icon Icon={ChevronLeft} size={6} />
    </IconButton>
  )
}
